//main
import ContentFormatXW from "../content/webc/content-format-xw";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import WebbDividerMedium from "../content/webb/webb-divider-md";
import HeaderSectionDark from "../content/webb/head-section-dark";

import EventsSearchWWModule from "../content/events/events-search";
import EventsListWWModule from "../content/events/events-list-ww";


export default function EventsListWW() {

  return (
  <>
    <ContentFormatXW 
      head='Events'
      link={`/home`}
      form= 'full'
      data= {
        <>
          <div className="back-color-dark text-center">
            <WebbDividerMedium/>
            <WebbDividerMedium/>
            <EventsSearchWWModule />
          </div>
          <WebbDividerMedium/>
          <EventsListWWModule />

        </>
      } 
    />
  </>
  )
}